// HoFeatures.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext'; // Asegúrate de ajustar la ruta de importación según tu estructura de proyecto

const styles = {
  featuresSection: {
    padding: '80px 0',
    background: 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
  },
  sectionTitle: {
    fontSize: '2.8rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
  },
  sectionDescription: {
    fontSize: '1.2rem',
    color: '#64748b',
    maxWidth: '800px',
    margin: '0 auto 60px',
    textAlign: 'center',
    lineHeight: '1.7',
  },
  featuresGrid: {
    display: 'grid',
    gap: '40px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
  },
  featureCard: {
    padding: '40px 30px',
    borderRadius: '20px',
    background: 'white',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    transition: 'all 0.4s ease',
    border: '1px solid rgba(255,255,255,0.2)',
    position: 'relative',
    overflow: 'hidden',
  },
  featureCardHover: {
    transform: 'translateY(-10px)',
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
  },
  featureIcon: {
    fontSize: '3.5rem',
    marginBottom: '20px',
    display: 'block',
    textAlign: 'center',
  },
  featureTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    marginBottom: '15px',
    color: '#1e293b',
    textAlign: 'center',
  },
  featureDescription: {
    color: '#64748b',
    lineHeight: '1.6',
    textAlign: 'center',
    fontSize: '1rem',
  },
};

function HoFeatures({ features, title: propTitle, description: propDescription }) {
  const { language } = useAuth();
  const [hoveredFeature, setHoveredFeature] = useState(null);

  // Traducciones
  const translations = {
    es: {
      title: "🎯 EmojiSurveys: Encuestas que Funcionan",
      description: "La plataforma más divertida y funcional para medir la satisfacción del cliente. Crea encuestas atractivas con emojis, obtén feedback inmediato y analiza resultados como un profesional.",
    },
    en: {
      title: "🎯 EmojiSurveys: Surveys that Work",
      description: "The most fun and functional platform for measuring customer satisfaction. Create engaging surveys with emojis, get immediate feedback, and analyze results like a pro.",
    }
  };

  // Seleccionar el idioma (por defecto español si no es "En")
  const lang = language === "es" ? "es" : "en";
  const finalTitle = propTitle || translations[lang].title;
  const finalDescription = propDescription || translations[lang].description;

  // Verificar que features existe y tiene elementos
  if (!features || features.length === 0) {
    return null;
  }

  return (
    <section id="features" style={styles.featuresSection}>
      <div style={styles.container}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 style={styles.sectionTitle}>{finalTitle}</h2>
          <p style={styles.sectionDescription}>{finalDescription}</p>
        </div>
        <div style={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div
              key={index}
              style={{
                ...styles.featureCard,
                ...(hoveredFeature === index ? styles.featureCardHover : {}),
              }}
              onMouseEnter={() => setHoveredFeature(index)}
              onMouseLeave={() => setHoveredFeature(null)}
            >
              <div style={styles.featureIcon}>{feature.icon}</div>
              <h3 style={styles.featureTitle}>{feature.title}</h3>
              <p style={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HoFeatures;